export default __webpack_public_path__ + "static/media/No.9-2.b0910bd8.jpg";